const masteringNL = {
    "view": {
        "table": {
            "title": "Uw Mastering Lijst",
            "column": {
                "created_by": "Gemaakt Door",
                "total_songs": "Aantal Liedjes",
                "mastered_songs": "Totaal Gemasterde Liedjes",
                "created": "Datum Gemaakt",
                "action": "Actie"
            },
            "button": {
                "open": "OPENEN",
                "edit": "BEWERKEN",
                "export_csv": "Exporteer CSV"
            },
            "placeholder": {
                "search": "Zoeken..."
            }
        },
        "message": {
            "noAccess": "U heeft geen toegang tot deze module, neem contact op met het ondersteuningsteam voor meer informatie.",
            "subscriptionExpired": "Uw abonnement is verlopen. Gelieve uw abonnement te <1>hervatten</1> om van deze functie gebruik te maken.",
            "subscriptionUpgrade": "Uw huidige abonnementsplan ondersteunt deze functie niet. Gelieve uw abonnementsplan te <1>upgraden</1> om van deze functie gebruik te maken.",
            "noCredits": "U heeft geen audiomasteringcredits meer. Meer informatie over credits vindt u <1>hier</1> en neem contact op met ons ondersteuningsteam.",
            "learnMore": "Leer alles over Audio Mastering <1>hier</1>. Voor meer informatie en <3>credits</3>, neem contact op met ons ondersteuningsteam."
        }
    },
    "add": {
        "form": {
            "step1": {
                "title": "Hoeveel liedjes wilt u masteren?",
                "label": {
                    "number_of_songs": "Aantal Liedjes"
                },
                "option": {
                    "songsCount": {
                        "selectNoOfSongs": "Selecteer aantal liedjes",
                        "song": "Liedje",
                        "songs": "Liedjes"
                    }
                },
                "button": {
                    "continue": "Doorgaan"
                }
            },
            "step2": {
                "title": "Selecteer uw liedjes voor mastering",
                "button": {
                    "save": "Opslaan"
                }
            }
        },
        "message": {
            "uploadSuccess": "Audiomastering Liedjes Succesvol Geüpload!",
            "creationSuccess": "Audiomastering is aangemaakt! Selecteer nu uw liedjes in de onderstaande sectie.",
            "error": "Er is een fout opgetreden. Probeer het opnieuw."
        },
        "modal": {
            "addMastering": {
                "header": "Weet u zeker dat u nieuwe mastering wilt toevoegen?",
                "body": "Opmerking: Dit zal resulteren in aftrek van {{credits}} credits."
            },
            "saveMastering": {
                "header": "Weet u zeker dat u Audio Mastering wilt opslaan?",
                "body": "Opmerking: Zorg ervoor dat u de juiste audiobestanden uploadt, aangezien ze niet kunnen worden gewijzigd zodra ze zijn opgeslagen."
            }
        }
    },
    "update": {
        "form": {
            "label": {
                "selectSongs": "Selecteer uw liedjes voor mastering"
            },
            "button": {
                "save": "Opslaan"
            }
        },
        "message": {
            "success": "Audiomastering Succesvol Bijgewerkt!",
            "errorCantUpdate": "Audiomastering kan niet worden bijgewerkt zodra de liedjes zijn geüpload!",
            "errorMasteringDoesNotExist": "Mastering kan niet worden bijgewerkt omdat het niet bestaat!",
            "error": "Er is een fout opgetreden. Probeer het opnieuw."
        },
        "modal": {
            "saveMastering": {
                "header": "Weet u zeker dat u Audio Mastering wilt opslaan?",
                "body": "Opmerking: Zorg ervoor dat u de juiste audiobestanden uploadt, aangezien ze niet kunnen worden gewijzigd zodra ze zijn opgeslagen."
            }
        }
    },
    "viewSongs": {
        "title": "Audiomastering Liedjes",
        "table": {
            "column": {
                "name": "Naam",
                "preset": "Preset",
                "intensityAndLoudness": "Intensiteit & Volume",
                "preview": "Voorbeeld",
                "master": "Master",
                "previewResult": "Voorbeeldresultaat",
                "masteringResult": "Masteringresultaat",
                "mastered": "Gemaseterd",
                "action": "Actie"
            },
            "label": {
                "previewAttemptsLeft": "{{count}} Over",
                "notAvailable": "Niet Beschikbaar"
            },
            "button": {
                "generate": "Genereren",
                "edit": "Bewerken",
                "exportCsv": "Exporteer CSV"
            },
            "option": {
                "preset": {
                    "acoustic": "Akoestisch",
                    "allGenres": "Alle Genres",
                    "classical": "Klassiek",
                    "clubHouseTechno": "Club - House - Techno",
                    "edmMusic": "EDM Muziek",
                    "electronic": "Elektronisch",
                    "electronicRaw": "Elektronisch Ruw",
                    "hipHop": "Hip Hop",
                    "hipHopBass": "Hip Hop Bas",
                    "popMusic": "Popmuziek",
                    "popRnB": "Pop & RnB",
                    "rockMetal": "Rock & Metal",
                    "trap": "Trap",
                    "vocalFocused": "Vocaal Gericht"
                }
            },
            "message": {
                "previewDownloadTooltip": "Het voorbeeld wordt gegenereerd. Wacht 5-6 minuten voordat het verschijnt.",
                "masteringDownloadTooltip": "Mastering is in proces. Wacht 7-15 minuten voordat het verschijnt.",
                "alreadyMasteredTooltip": "Dit liedje is al gemasterd."
            }
        },
        "message": {
            "error": "Er is iets misgegaan! Vernieuw de pagina en probeer het opnieuw!",
            "successMaster": "Liedje verzonden voor Mastering generatie!<br/>Opmerking: Controleer over een paar minuten, aangezien het 7-15 minuten duurt om mastering te genereren.",
            "successPreview": "Liedje verzonden voor Mastering Voorbeeld generatie!<br/>Opmerking: Controleer over een paar minuten, aangezien het 5-6 minuten duurt om een masteringvoorbeeld te genereren."
        },
        "modal": {
            "generateMastering": {
                "header": "Genereer Mastering",
                "body": "Weet u zeker dat u mastering wilt genereren? Dit is een onomkeerbare actie! Het masterresultaat verschijnt binnen 7-15 minuten.",
                "message": {
                    "success": "Liedje verzonden voor Mastering generatie!"
                }
            },
            "generateMasteringPreview": {
                "header": "Genereer Mastering Voorbeeld",
                "body": "Weet u zeker dat u een masteringvoorbeeld wilt genereren? Het voorbeeldresultaat verschijnt binnen 5-6 minuten",
                "message": {
                    "success": "Liedje verzonden voor Mastering Voorbeeld generatie!"
                }
            }
        }
    },
    "songParametersUpdate": {
        "title": "Bewerk Liedparameters",
        "form": {
            "label": {
                "intensity": "Intensiteit",
                "loudness": "Volume",
                "preset": "Preset"
            },
            "placeholder": {
                "preset": "Selecteer Preset"
            },
            "option": {
                "preset": {
                    "acoustic": "Akoestisch",
                    "allGenres": "Alle Genres",
                    "classical": "Klassiek",
                    "clubHouseTechno": "Club - House - Techno",
                    "edmMusic": "EDM Muziek",
                    "electronic": "Elektronisch",
                    "electronicRaw": "Elektronisch Ruw",
                    "hipHop": "Hip Hop",
                    "hipHopBass": "Hip Hop Bas",
                    "popMusic": "Popmuziek",
                    "popRnB": "Pop & RnB",
                    "rockMetal": "Rock & Metal",
                    "trap": "Trap",
                    "vocalFocused": "Vocaal Gericht"
                }
            },
            "button": {
                "submit": "Indienen"
            },
            "message": {
                "intensityTooltip": "De hoeveelheid dynamiek, EQ en verwerking die op uw liedje wordt toegepast in relatie tot het totale nummer en de geselecteerde preset. Maximale benutting vindt plaats bij 100 %. We raden aan om met deze instelling te experimenteren om de sweet spot te vinden die het beste bij u past.",
                "loudnessTooltip": "Het geïntegreerde luidheidsdoelniveau. Gemeten in luidheidsunits ten opzichte van volledige schaal (LUFS). We raden aan om met deze instelling te experimenteren om de sweet spot te vinden die het beste bij u past. Afhankelijk van de stijl en het genre van uw liedje, zouden de beste resultaten moeten verschijnen bij -15 tot -9 db"
            }
        },
        "message": {
            "success": "Liedparameters zijn bijgewerkt!",
            "error": "Er is iets misgegaan! Vernieuw de pagina en probeer het opnieuw!",
            "songMastered": "Liedparameters kunnen niet worden bijgewerkt zodra het liedje is gemasterd!"
        }
    },
    "songRow": {
        "label": {
            "songs": "Liedjes",
            "name": "Naam",
            "genre": "Genre",
            "preset": "Preset",
            "intensity": "Intensiteit",
            "loudness": "Volume",
            "audioFile": "Audiobestand"
        },
        "placeholder": {
            "name": "bijv. Liednaam",
            "genre": "bijv. Pop",
            "preset": "Selecteer Preset"
        },
        "option": {
            "preset": {
                "acoustic": "Akoestisch",
                "allGenres": "Alle Genres",
                "classical": "Klassiek",
                "clubHouseTechno": "Club - House - Techno",
                "edmMusic": "EDM Muziek",
                "electronic": "Elektronisch",
                "electronicRaw": "Elektronisch Ruw",
                "hipHop": "Hip Hop",
                "hipHopBass": "Hip Hop Bas",
                "popMusic": "Popmuziek",
                "popRnB": "Pop & RnB",
                "rockMetal": "Rock & Metal",
                "trap": "Trap",
                "vocalFocused": "Vocaal Gericht"
            }
        },
        "message": {
            "intensityTooltip": "De hoeveelheid dynamiek, EQ en verwerking die op uw liedje wordt toegepast in relatie tot het totale nummer en de geselecteerde preset. Maximale benutting vindt plaats bij 100 %. We raden aan om met deze instelling te experimenteren om de sweet spot te vinden die het beste bij u past.",
            "loudnessTooltip": "Het geïntegreerde luidheidsdoelniveau. Gemeten in luidheidsunits ten opzichte van volledige schaal (LUFS). We raden aan om met deze instelling te experimenteren om de sweet spot te vinden die het beste bij u past. Afhankelijk van de stijl en het genre van uw liedje, zouden de beste resultaten moeten verschijnen bij -15 tot -9 db",
            "audioFileTooltip": "Ondersteunde audioformaten zijn: AAC, AIFF, FLAC, MP3, OPUS, VORBIS en WAV. We raden sterk aan om verliesvrije bestandstypen zoals AIFF, FLAC of WAV te gebruiken. Onze masteringtool retourneert altijd hetzelfde bestandstype als het originele bestand. Houd er rekening mee dat u een 16-bit, 44,1 kHz WAV-bestand nodig heeft voor de distributie.",
            "errorSongNameRequired": "Voer de naam van het liedje in",
            "errorSongNameLength": "De naam van het liedje mag niet meer dan 80 tekens bevatten.",
            "errorGenreRequired": "Voer het genre van het liedje in",
            "errorGenreLength": "Het genre van het liedje mag niet meer dan 50 tekens bevatten.",
            "errorPresetRequired": "Preset moet geselecteerd worden.",
            "errorAudioFileRequired": "Selecteer een liedbestand",
            "errorAudioFileValid": "Upload een geldig audiobestand"
        }
    },
    "masteringConfirmModal": {
        "header": "Weet u zeker dat u Audio Mastering wilt opslaan?",
        "body": "Opmerking: Zorg ervoor dat u de juiste audiobestanden uploadt, aangezien ze niet kunnen worden gewijzigd zodra ze zijn opgeslagen.",
        "button": {
            "cancel": "Annuleren",
            "confirm": "Bevestigen"
        },
        "message": {
            "error": "Er is iets misgegaan! Vernieuw de pagina en probeer het opnieuw!"
        }
    }
};

export default masteringNL;